class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {    
    this.initFreeShippingBar();

    this.notification.classList.remove('twcss-hidden');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.notification.classList.add('twcss-hidden');
    document.body.removeEventListener('click', this.onBodyClick);

    //Screoll to the top
    document.body.scrollTop = 0;

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {      
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initFreeShippingBar() {
    let shippingBar = document.getElementById('drawer-free-shipping-bar');
    this.updateShippingBar(shippingBar);
  }

  async updateShippingBar(shippingBar) {
    //DIFFERENT RATE IS SET FOR WHOLESALE CUSTOMERS AND OUTSIDE OF UK
    if(shippingBar.dataset.wholesale === 'true' || shippingBar.dataset.currency !== '£') {
      this.hideShippingBar();
      return;
    }

    let cartTotal = await this.getCartTotal();
    if(cartTotal === null) { return; }
    let currentCartTotal = Number(this.formatMoney(cartTotal, shippingBar.dataset.moneyFormat).replace(shippingBar.dataset.currency, '')); //TEST STAT

    let shippingRate = shippingBar.dataset.shippingRate;
    let priceDifference = shippingRate - currentCartTotal;
    let shippingBarTitle = shippingBar.querySelector('#shipping-bar-title');
    let shippingBarProgress = shippingBar.querySelector('#shipping-bar-progress')

    shippingBarTitle.innerHTML = '';
    if(currentCartTotal >= shippingRate) {
      shippingBarTitle.innerHTML = shippingBar.dataset.achieveFreeShipping;
    } else {
      //Update title
      let titlePrice = shippingBar.dataset.currency + priceDifference.toFixed(2)
      let prepSectionTitle = shippingBar.dataset.sectionTitle.replace("{PRICE}", titlePrice);
      shippingBarTitle.innerHTML = prepSectionTitle;
    }

    //Updating progress bar
    let percentage = (currentCartTotal / shippingRate) * 100;
    shippingBarProgress.style.width = `${percentage}%`;

  }

  hideShippingBar() {
    let shippingBar = document.getElementById('drawer-free-shipping-bar');
    shippingBar.style.display = 'none';
  }

  getCartTotal() {
    return fetch('/cart.js').then(response => response.json()).then(cart => {
      return cart.total_price;
    }).catch(error => {
      console.error('Error fetching cart:', error)
      return null;
    });
  }

  formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let money_format = "{{ shop.money_format }}"
    let formatString = format || money_format;
  
  
    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }
  
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");
  
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      let parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";
  
      return dollars + cents;
    }
  
  
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }

}

customElements.define('cart-notification', CartNotification);
